import {ReactElement} from "react";
import {Box, Button, Typography, useMediaQuery} from "@mui/material"
import {Trans, useTranslation} from "react-i18next";
import SimpleBar from "simplebar-react";
import 'simplebar-react/dist/simplebar.min.css';

import {theme} from "../../../../utils";
import TranslationMsg from '../../transMessage';

import {CommonDialog} from "../../../dialog/CommonDialog";
import {termsDialogStyles, ITermsDialogProps} from './termsDialog-helpers';

const i18nCustomComponents = {
    br: <br/>,
    b: <b></b>,
    nbsp: <>{'\u00A0'}</>,
    // eslint-disable-next-line
    a: <a href="mailto:support@hypercept-ga.com"></a>
} as unknown as { [key: string]: ReactElement };

export const TermsDialog = (props: ITermsDialogProps) => {
    const {showTermsDialog, onCloseTermsDialog, contentData} = props
    const {t} = useTranslation();
    const isMobileX = useMediaQuery(theme.breakpoints.down(900))

    const handleClose = () => {
        if (onCloseTermsDialog) {
            onCloseTermsDialog()
        }
    };

    return (
        <CommonDialog
            isDialogVisible={showTermsDialog}
            headerLabel={contentData?.title}
            headerTitleSx={termsDialogStyles.headerTitleSx}
            headerSubTitleSx={{...termsDialogStyles.headerSubTitleSx, fontWeight: 400}}
            maxDialogWidth="md"
            onDialogClose={handleClose}>
            <Box textAlign={'left'}>
                <SimpleBar style={{
                    ...termsDialogStyles.scrollWrapper,
                    maxHeight: isMobileX ? "250px" : "450px",
                    width: isMobileX ? "80%" : "93%"
                }}>
                    <Box>
                        <Typography sx={termsDialogStyles.contentLabel}>
                            <Trans
                                i18nKey={TranslationMsg.TERMS_DESCRIPTION}
                                components={{br: <br/>, b: <b></b>}}/>
                        </Typography>
                        {contentData?.data?.length > 0 ? contentData.data.map((item: any, index: number) => {
                            return (
                                <Box sx={{mt: index !== 0 ? "1.25rem" : "0px", pr: "50px"}} key={index + 1}>
                                    <Typography
                                        sx={{...theme.typography.body1SemiBold}}>{index + 1}. {item?.title}</Typography>
                                    <Typography sx={termsDialogStyles.subContent}>
                                        <Trans
                                            i18nKey={item?.content}
                                            components={i18nCustomComponents}/>
                                    </Typography>
                                    <ol type="a">
                                        {item?.subContentList?.length > 0 ? item.subContentList.map((el: any, elInd: number) => {
                                            return (
                                                <div key={elInd + 1}>
                                                    <li style={{
                                                        ...termsDialogStyles.subContent,
                                                        marginTop: "0px",
                                                        paddingLeft: '5px'
                                                    }}>
                                                        <Typography>
                                                            <Trans
                                                                i18nKey={el?.body}
                                                                components={i18nCustomComponents}/>
                                                        </Typography>
                                                    </li>
                                                    <ol type="i">
                                                        {el?.bodyList?.length > 0 ? el.bodyList.map((val: any, valInd: number) => {
                                                            return (
                                                                <li key={valInd + 1} style={{
                                                                    ...termsDialogStyles.subContent,
                                                                    marginTop: "0px"
                                                                }}>
                                                                    <Trans
                                                                        i18nKey={val?.listContent}
                                                                        components={i18nCustomComponents}/>
                                                                </li>
                                                            )
                                                        }) : null}
                                                    </ol>
                                                </div>
                                            )
                                        }) : null}
                                    </ol>
                                </Box>
                            )
                        }) : null}
                    </Box>
                </SimpleBar>
                <Box display={"flex"} justifyContent={isMobileX ? "center" : "flex-end"} mt={'33px'}
                     mb="24px" sx={{px: "32px"}}>
                    <Button
                        onClick={handleClose}
                        variant={'contained'}
                        sx={termsDialogStyles.closeButtonWrapper}>
                        <Typography sx={{
                            ...theme.typography.components.montseratButtonContainedLabel,
                            color: "#fff"
                        }}>{t(TranslationMsg.CLOSE_BTN)}</Typography>
                    </Button>
                </Box>
            </Box>
        </CommonDialog>
    )
}
